var impressum = "Vizitka";
var privacy = "Zasebnost in pravna obvestila";
var recallInfo = "Informacije o odpoklicu";
var signOut = "Odjava";
var sl_si = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { sl_si as default, impressum, privacy, recallInfo, signOut };
